<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-center">EMBEDDED PROGRAMMING</h1>
      </div>

      <div v-for="(game, gameIndex) in games" :key="gameIndex" class="animation col-xs-12">
        <!-- Carousel container -->
        <div :id="`my-pics${gameIndex}`" class="carousel slide" data-ride="carousel">
          <!-- Content -->
          <div class="carousel-inner" role="listbox">
            <!-- Slide -->
            <div class="item active">
              <img :src="require(`@/assets/gallery/embedded/${gameIndex + 1}.png`)" alt="" />
            </div>
          </div>
        </div>
        <div class="desc">
          <h2>{{ game.title }}</h2>
          <p v-html="game.desc"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //Slide show (bootstrap 3 carousel) link:
  //https://www.quackit.com/bootstrap/bootstrap_3/tutorial/bootstrap_carousel.cfm
  data() {
    return {
      games: [
        {
          title: 'Training for Arduino programming',
          desc:
            `Training at the “School Center - Kranj”, Republic of Slovenia.`,
        },
        {
          title: 'Project development',
          desc:
            `Developing projects in the laboratory at SETUGS “Mihajlo Pupin” - Skopje.`,
        },
        {
          title: 'Project BL (Better Life)',
          desc:
            `A garage that is controlled via a remote control. Built with Arduino Mega 2560.`,
        },
        {
          title: 'Project Remote Car',
          desc:
            `A car that is controlled via a remote control. Built with Arduino Uno.`,
        },
        {
          title: 'Presentation of the Projects BL and Remote Car',
          desc:
            `Presentation of my work on the event “Days of Electrical Engineering” in SETUGS “Mihajlo Pupin” - Skopje.`,
        },
      ]
    }
  }
}
</script>

<style>
/* Global CSS outside the scoped attribute */
:root {
  --embedded-primary-color: #ffea00;
  --embedded-secondary-color: #654f00;
}
</style>

<style scoped>
/* Scoped CSS for your component */
.container {
  color: var(--embedded-primary-color);
  margin-bottom: 50px;
  padding: 20px;
}

h1 {
  /*text-shadow: 0px 0px 2px crimson;*/
  margin-bottom: 40px;
  color: var(--embedded-primary-color);
  /* Using the primary color variable */
}

p {
  margin-top: 5px;
  text-align: justify;
  font-size: 18px;
}

.animation {
  background-color: var(--embedded-secondary-color);
  /* Using the secondary color variable */
  border: 1px solid var(--embedded-primary-color);
  /* Using the primary color variable */
  border-radius: 4px;
  box-shadow: 0px 0px 5px var(--embedded-primary-color);
  /* Using the primary color variable */
  padding: 1px;
  margin-bottom: 70px;
}

.desc {
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border: 2px solid var(--embedded-primary-color);
  /* Using the primary color variable */
  border-radius: 4px;
}

.desc h2 {
  margin-top: 10px;
}

.download-btn {
  background-color: var(--embedded-primary-color);
  /* Using the primary color variable */
  border: 2px solid white;
  border-radius: 4px;
  box-shadow: 0px 0px 5px white;
  margin-bottom: 10px;
  color: white;
  font-size: 16px;
}

.download-btn:hover {
  background-color: white;
  color: var(--embedded-primary-color);
  /* Using the primary color variable */
  border: 2px solid var(--embedded-primary-color);
  /* Using the primary color variable */
}

@media screen and (min-width: 992px) {
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
}

section {
  /*background-color: #111845;*/
  min-height: 100vh;
}</style>
